import { render, staticRenderFns } from "./AddDocumentType.vue?vue&type=template&id=356d1c74&scoped=true"
import script from "./AddDocumentType.vue?vue&type=script&lang=js"
export * from "./AddDocumentType.vue?vue&type=script&lang=js"
import style0 from "./AddDocumentType.vue?vue&type=style&index=0&id=356d1c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356d1c74",
  null
  
)

export default component.exports